import React, { FC } from 'react';
import PrimaryNavigation from '../../components/core/PrimaryNavigation/PrimaryNavigation';
import TableDetailGroup from '../../components/core/TableDetailGroup/TableDetailGroup';
import TableGroupUser from '../../components/core/TableGroupUsers/TableGroupUsers';



interface MaintaninerDetailProps {}

const MaintainerDetail: FC<MaintaninerDetailProps> = () => (
  <div className=''>
    <div className="body">
      <header className="header">
      <div className="header-content responsive-wrapper">
        <PrimaryNavigation></PrimaryNavigation>
        </div>
      </header>
      <main>
      <div className="responsive-wrapper">
		<div className="main-header">
		</div>
	
		<div className="content-header">
			<div className="content-header-intro">
      <br></br>
      <h2 className="pds-contentTeaser-heading pds-typography-h1"><strong>Detalle de Grupos de Usuarios</strong></h2>
      
      </div>
      </div>
      <div className='content'>
        <div className='content-main'>
          <div className='container'>
           <TableDetailGroup></TableDetailGroup>
          </div>
        </div>
      </div>
      </div>
      </main>
      
    </div>
  </div>
);

export default MaintainerDetail;